type Props = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionTitle({ eyebrow, title, desc, align = "left" }: Props) {
  const center = align === "center";
  return (
    <div className={`${center ? "mx-auto text-center" : ""} max-w-2xl`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          <i className="ri-sparkling-2-line text-xs"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl font-bold tracking-wide text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 text-sm leading-7 text-foreground-600 md:text-base ${center ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}